import 'css-chunksrc/client/pages/projectPage/discussionsPage/loader/discussion/styles.scss';export default {
  "discussion": "_discussion_159dv_1"
};